export default {"src":"/_next/static/media/customer_service.d568ebe9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};